import { Link } from "react-router-dom";
import { CellProps } from "react-table";
import Status from "src/components/status/Status";
import TextCell from "src/components/tables/cells/TextCell";
import { PR_PO_STATUS_CELL, PR_STATUS } from "src/utils/constants";
import { PurchaseOrderType } from "./purchase-order-types";

const usePurchaseOrderTableColumns = () => {
  return [
    {
      Header: "Order ID",
      accessor: "id",
      className: "min-w-[180px]",
      Cell: ({ row: { original } }: CellProps<PurchaseOrderType>) => (
        <Link
          to={`/store/vendor/purchase-orders/create/${original.id}`}
          className="text-[#0C8CE9]"
        >
          <TextCell value={`#${original.id}`} />
        </Link>
      ),
    },
    {
      Header: "Date Issued",
      accessor: "dateIssued",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Total Amount",
      accessor: "totalPrice",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "PO Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ value }: { value: PR_STATUS }) => {
        const status = PR_PO_STATUS_CELL[value];
        return <Status {...status} />;
      },
    },
    {
      Header: "Delivery Deadline",
      accessor: "deadline",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    // {
    //   Header: "Actions",
    //   accessor: "",
    //   className: "min-w-[200px]",
    //   Cell: ({ value }: CellProps<PurchaseOrderType>) => (
    //     <ActionsCell value={value} onDelete={() => {}} />
    //   ),
    // },
  ];
};

export default usePurchaseOrderTableColumns;
